<template>
  <div class="md-layout md-gutter">
    <div class="md-layout-item md-size-100 md-small-size-100">
      <div class="md-layout-item md-size-100">
        <DeviceCreateCard/>
      </div>
    </div>
  </div>
</template>

<script>

import DeviceCreateCard from "@/pages/Dashboard/Devices/Create/Form/DeviceCreateCard.vue";

export default {
  name: "CreateDevices",
  components: {
    DeviceCreateCard,
  }
}
</script>
